import React from "react";
import Contactus from "../Components/Contactus";
import { motion } from "framer-motion";
import { useLanguage } from "../Router/LanguageContext";

export default function ContactUs() {
  const { dictionary } = useLanguage();
  return (
    <>
      <div className="section-main">
        <div className="section section-contact-us commonHeaderPadding">
          <div className="bg-colored"></div>
          <div className="container-fluid maxContainerSection container-contact-us">
            <div className="row">
              <div className="col-lg-12 col-md-12 text-center desc-in-cont">
                <h2 className="m-0 f-w-600 f-s-36 contact-us-title">
                  {dictionary?.contactTitle}
                </h2>
                <p className="m-0 f-s-20">{dictionary?.contactSubtitle1}</p>
                <p className="m-0 f-s-20">{dictionary?.contactSubtitle2}</p>
                {/* <button className="radius-btn btn-r-a-q">
                  <span className="btn-text">Receive a quote!</span>
                </button> */}
              </div>
            </div>

            <div className="row row-office">
              {/* Left Column */}
              <div className="col-md-4 d-flex justify-content-start">
                <motion.div
                  className="office-card"
                  initial={{ scale: 1 }}
                  whileHover={{
                    scale: 1.02,
                    transition: { duration: 0.25, ease: "easeInOut" },
                  }}
                >
                  <img src="/assets/img/icon-building.svg" alt="" />
                  <h5 className="m-0 f-w-600 f-s-20">
                    {dictionary?.adminOffice}
                  </h5>
                  <p className="m-0 f-s-16">
                    Ingombota Palace Building,
                    <br /> 3rd Floor, Luanda
                  </p>
                </motion.div>
              </div>

              {/* Center Column */}
              <div className="col-md-4 d-flex justify-content-center">
                <motion.div
                  className="office-card"
                  initial={{ scale: 1 }}
                  whileHover={{
                    scale: 1.02,
                    transition: { duration: 0.25, ease: "easeInOut" },
                  }}
                >
                  <img src="/assets/img/icon-card.svg" alt="" />
                  <h5 className="m-0 f-w-600 f-s-20">
                    {dictionary?.operationalOffice}
                  </h5>
                  <p className="m-0 f-s-16">
                    Sonils Base,
                    <br /> Luanda
                  </p>
                </motion.div>
              </div>

              {/* Right Column */}
              <div className="col-md-4 d-flex justify-content-end">
                <motion.div
                  className="office-card"
                  initial={{ scale: 1 }}
                  whileHover={{
                    scale: 1.02,
                    transition: { duration: 0.25, ease: "easeInOut" },
                  }}
                >
                  <img src="/assets/img/icon-globe.svg" alt="" />
                  <h5 className="m-0 f-w-600 f-s-20">
                    {dictionary?.southAfrica}
                  </h5>
                  <p className="m-0 f-s-16">
                    The Estuaries, Bldg 12,
                    <br /> Century City, Cape Town, 7441
                  </p>
                </motion.div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="contact-us-outer">
        <div className="row">
          <div className="col-md-12 whowearehedaersection ourSolutionSectionHeader">
            <h2 className="m-0 f-s-48"> {dictionary?.getInTouchTitle}</h2>
            <p className="m-0 f-s-20 ">{dictionary?.getInTouchDesc}</p>
          </div>
        </div>
        <Contactus />
      </div>
    </>
  );
}
